import { Injectable, Inject } from "@angular/core";
import { AppConfig } from "src/environments/appconfig";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ParametroPaginacionGenerico } from "src/app/util/ParametroPaginacionGenerico";
import { CoTipopago } from "../dominio/CoTipopago";
import { UHttpsClient } from "../../../../seguridad/seguridad/uhttpsClient";

@Injectable()
export class CoTipoPagoServicio {

    private url = `${this.config.getEnv('proxy')}spring/comercial/cotipopago/`;
    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    constructor(private http: UHttpsClient, private config: AppConfig) { }

    public listarActivos(): Promise<CoTipopago[]> {
        return this.http.get(`${this.url}listarActivos`,{headers: this.headers})
            .toPromise()
            .then(response => {
                return response as CoTipopago[];
            })
            .catch(error => []);
    }
}

